import Reflux from 'reflux'
import CommandActions from '../actions/CommandActions'

export var DiaLogMapEditorsStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.diaLogMapEditors,'onDiaLogMapEditors');
	},
	onDiaLogMapEditors(diaLogId,result)
	{
		this.trigger(diaLogId,result);
	}
});

export var CommandMapEditorsStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.commandArgMapEditors,'onCommandArgMapEditors');
	},
    onCommandArgMapEditors(name,map,moduleInstanceId)
    {
		this.trigger(name,map,moduleInstanceId);
    }
});

export var GetSelectRecordsKeyStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.getSelectRecordsKey,'onGetSelectRecordsKey');
	},
	onGetSelectRecordsKey(keys,groupAlias,menuItemId,formId,moduleInstanceId)
	{
		this.trigger(keys,groupAlias,menuItemId,formId,moduleInstanceId)
	}
});

export var GetSelectRecordsStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.getSelectRecords,'onGetSelectRecords');
	},
	onGetSelectRecords(selectedRecords,groupAlias,moduleInstanceId,containsSelectedRecordKey=false)
	{
		this.trigger(selectedRecords,groupAlias,moduleInstanceId,containsSelectedRecordKey);
	}
});


export var SelectAllRecordsStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.selectAllRecords,'onSelectAllRecords');
	},
	onSelectAllRecords(value,groupAlias,moduleInstanceId)
	{
		this.trigger(value,groupAlias,moduleInstanceId);
	}
});

/*export var SelectRecordsStore2 = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.selectedRecords2,'onSelectRecords2');
	},
	onSelectRecords2(value,groupAlias,moduleInstanceId,records)
	{
		this.trigger(value,groupAlias,moduleInstanceId,records);
	}
});*/

export var SelectRecordsStore2 = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.selectRecords2,'onSelectRecords2');
	},
	onSelectRecords2(value,groupAlias,moduleInstanceId,records)
	{
		this.trigger(value,groupAlias,moduleInstanceId,records);
	}
});

export var ReverseSelectRecordsStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.reverseSelectedRecords,'onReverseSelectedRecords');
	},
	onReverseSelectedRecords(groupAlias)
	{
		this.trigger(groupAlias);
	}
});

export var CallComponentFuncStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.callComponentFunc,'onCallComponentFunc');
	},
	onCallComponentFunc(entityId,innerId,funcName,funcArg,result)
	{
		this.trigger(entityId,innerId,funcName,funcArg,result);
	}
});

export var ButtonShortCutStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CommandActions.buttonShortCut,'onButtonShortCut');
	},
	onButtonShortCut(shortCut,moduleInstanceId)
	{
		this.trigger(shortCut,moduleInstanceId);
	}
});

export var GetColumnLengthProperties = Reflux.createStore({

	init:function()
	{
		this.listenTo(CommandActions.getColumnLengthProperties,'onGetColumnLengthProperties');
	},
	onGetColumnLengthProperties(arg)
	{
		this.trigger(arg);
	}

});


// WEBPACK FOOTER //
// ./src/stores/CommandStore.js